
export const document = window.document,
	styleSheets = document.styleSheets,
	root = document.body || document.getElementsByTagName('head')[0];
